module.exports = __webpack_public_path__ + "img/audio_classify7.7b2af1a9.png";